/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { combineReducers } from 'redux';
import brandReducer from './brand/reducer';
import childWindowReducer from './child-windows/reducer';
import deviceReducer from './device/reducer';
import dsToolkitReducer from './dstoolkit/reducer';
import fieldsReducer from './fields/reducer';
import fieldGroupsReducer from './field-groups/reducer';
import formsReducer from './forms/reducer';
import formDependenciesReducer from './form-dependencies/reducer';
import fieldMessagesReducer from './field-messages/reducer';
import fragmentsReducer from './fragments/reducer';
import interdictionReducer from './interdiction/reducer';
import labelsReducer from './labels/reducer';
import stringsReducer from './strings/reducer';
import workingReducer from './working/reducer';
import fontsReducer from './fonts/reducer';
import cmsReducer from './cms/reducer';
import wfCmsReducer from './wf-cms/reducer';
import ariaLiveReducer from './aria-live/reducer';
import scrollBlockersReducer from './scroll-blockers/reducer';
var digitalCoreReducer = combineReducers({
  brand: brandReducer,
  childWindows: childWindowReducer,
  device: deviceReducer,
  dsToolkit: dsToolkitReducer,
  fields: fieldsReducer,
  fieldGroups: fieldGroupsReducer,
  fieldMessages: fieldMessagesReducer,
  forms: formsReducer,
  formDependencies: formDependenciesReducer,
  interdiction: interdictionReducer,
  labels: labelsReducer,
  fragments: fragmentsReducer,
  strings: stringsReducer,
  working: workingReducer,
  useWFFonts: fontsReducer,
  cms: cmsReducer,
  wfCms: wfCmsReducer,
  ariaLive: ariaLiveReducer,
  scrollBlockers: scrollBlockersReducer
});
export default digitalCoreReducer;